module.exports = __webpack_public_path__ + "static/logo-e086e2ddad5ca9c893863fd84095ecc5.png";